import client from 'api/client';
import { AxiosResponse, AxiosRequestConfig } from 'axios';

export function getExpertiseList(
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<string[]>> {
    return client.get<string[]>('/expertise_list', customConfig);
}

export function getResidenceStatusList(
    country: string,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<string[]>> {
    return client.get<string[]>(`/residential_status/${country}`, customConfig);
}
